import {Observable, ReplaySubject} from 'rxjs';
import {Injectable} from '@angular/core';

import {map, mergeMap} from 'rxjs/operators';
import {Browser} from '@webmate-web-core/shared/types/browser';
import {VehicleOffer} from "@webmate-web-core/shared/types/vehicles";
import {DeviceApi} from "@webmate-web-core/shared/api/rest/device.restapi";
import {ProjectId} from "@webmate-web-core/shared/types/ids";

/**
 * Repository managing Device Templates.
 */
@Injectable({
    providedIn: 'root'
})
export class VehicleService {

    constructor(private deviceApi: DeviceApi) {}

    getVehicleOffersForProject$(projectId: ProjectId): Observable<VehicleOffer[]> {
        return this.deviceApi.getVehicleOffersInProject(projectId);
    }

}
